import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import apis from './api'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './assets/css/base.css'
import './assets/css/style.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// If you use Swiper 6.0.0 or higher
import 'swiper/swiper-bundle.css'

import 'amfe-flexible/index.js'

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

Vue.use(ViewUI)

Vue.prototype.$api = apis

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
